import * as React from 'react'
import { SVGProps } from 'react'

const SvgLockWithKeyHole = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 200 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M51 47.212a6 6 0 0 1 6-6h85.024a6 6 0 0 1 6 6V114a6 6 0 0 1-6 6H57a6 6 0 0 1-6-6V47.212Z"
      fill="#00D37E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.68 84.439a12.116 12.116 0 0 0 6.064-10.5c0-6.694-5.43-12.121-12.128-12.121s-12.128 5.427-12.128 12.121c0 4.487 2.439 8.404 6.064 10.5v12.167a4 4 0 0 0 4 4h4.128a4 4 0 0 0 4-4V84.439Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.596 33.958C65.596 15.204 80.799 0 99.553 0c18.754 0 33.958 15.204 33.958 33.958v7.254h-13.351v-7.986c0-11.603-9.406-21.01-21.01-21.01-11.602 0-21.008 9.407-21.008 21.01v7.986H65.596v-7.254Z"
      fill="#00A965"
    />
  </svg>
)

export default SvgLockWithKeyHole
